import '../vendor/swiper.min.js';

const hero = {
	$this: $( '.js-carousel' ),
};

hero.init = function() {

	// init global variable
	var mySwiper = undefined;

	// create new swiper
	function createSwiper() {
		mySwiper = new Swiper ('.hero-container', {
			slidesPerView: 'auto',
			direction: 'horizontal',
			loop: true,
			navigation: {
				nextEl: '.js-swiper-next',
			},
			on: {
				init: callback(),
			}
		});

		// call imageLoader function on init & on each slide change
		mySwiper.on('slideChange', callback());

		function callback( e ) {
			$( '.swiper-container .load-image' ).imageLoader({
				ready: function(prop) {},
				resize: function(prop) {}
			});
			hero.$this.icons.init( '.svg-icon' );
		}
	}

	// Check if the swiper should be initiated.
	// initiates if mobile && there is no swiper or swiper got destroyed
	function shouldCreateSwiper() {
		if ($(window).width() > 1024 - 15 && (mySwiper && !mySwiper.destroyed )) {
			mySwiper.destroy(true, true);
			$('.js-carousel').removeClass('swiper-container');
			$('.hero-wrapper').removeClass('swiper-wrapper');
			$('.hero-slide').removeClass('swiper-slide');
		} else if ($(window).width() < 1024 - 15 && (!mySwiper || mySwiper.destroyed ) ) {
			$('.js-carousel').addClass('swiper-container');
			$('.hero-wrapper').addClass('swiper-wrapper');
			$('.hero-slide').addClass('swiper-slide');
			createSwiper();
		}
	}

	$(window).resize(function() {
		shouldCreateSwiper();
	});

	shouldCreateSwiper();

};

export { hero };
